import { useState, useEffect } from "react";
import queryString from "query-string";
import { Button } from "@components";
import { LinkDocument } from "@components";
import { ReportAPINew } from "@api";
import moment from "moment";
import { useTranslation } from "react-i18next";

function FinancialReportBulanan() {
  const {t} = useTranslation();
  const [yearCollection, setYearCollection] = useState();
  const [financialReport, setFinancialReport] = useState();
  const [loadFinancialReport, setLoadFinancialReport] = useState(false);

  useEffect(() => {
    const getFinancialReport = async (year) => {
      const filter = {
        cat: "laporan_bulanan",
        orderBy: "asc",
        from: `${year}-01-01`,
        to: `${year}-12-31`,
        perPage: 100,
      };

      const { data } = await ReportAPINew(queryString.stringify(filter));
      setFinancialReport(data.data != null ? data.data.result : []);
    };
    const getYearCollection = () => {
      const currentYear = new Date().getFullYear();
      let collection = [];

      for (let x = currentYear - 5; x < currentYear; x++) {
        collection.push({
          year: x,
          selected: false,
        });
      }

      collection.push({
        year: currentYear,
        selected: true,
      });

      setYearCollection(collection);
      getFinancialReport(currentYear);
    };

    if (!yearCollection) {
      getYearCollection();
    }

    if (loadFinancialReport) {
      getFinancialReport(
        yearCollection.filter((data) => data.selected)[0].year
      );
    }
  }, [yearCollection, loadFinancialReport]);

  const selectYear = (year) => {
    setYearCollection(
      yearCollection.map((data) => {
        return { ...data, ...{ selected: year === data.year } };
      })
    );
    setLoadFinancialReport(true);
  };

  const filterByYear = () => {
    const data = !!financialReport
      ? financialReport.filter((data) => {
          return true;
        })
      : [];
    return data;
  };

  return (
    <div className="financial-report-tab-section">
      <div className="filter-box">
        <div className="title">{t("pilih_tahun")}</div>
        <div className="filter-list">
          {!!yearCollection
            ? yearCollection.map((value, i) => {
                return (
                  <Button
                    label={value.year}
                    selected={value.selected}
                    key={i}
                    onClick={() => selectYear(value.year)}
                  />
                );
              })
            : ""}
        </div>
      </div>
      <div className="card-link">
          {filterByYear().map((data, i) => {
            return (              
              <LinkDocument
                label={moment(
                  data.created_date,
                  "DD-MM-YYYY hh:mm:ss"
                ).format("DD MMMM YYYY")}
                title={data.title}
                linkRedirect={data.file}
                rowLine="1"
                key={i}
              />              
            );
          })}
        </div>
    </div>
  );
}

export default FinancialReportBulanan;
